<template>
  <div>
      <h1 class="my-faq">{{ $t('FAQ') }}</h1>
      <div v-html="dataset"></div>
  </div>
</template>

<script>
export default {
  data() {
      return {
          dataset: "",
          defaultThemeColor: "",
          isThemeDark: false,
      };
  },
  created() {
      eventBus.$on('theme-change', (data) => {
          if (data === 'theme-dark') {
              this.isThemeDark = true;
          } else {
              this.isThemeDark = false;
          }
      });
  },
  methods: {
      actInitFaq(flagActive) {

          if (flagActive) {
              window.actScrollView = function () {
                  const items = document.querySelectorAll("button");

                  for (let item of items) {
                      item.setAttribute("aria-expanded", false);
                      item.children[2] &&
                          item.children[2].setAttribute("aria-expanded", false);
                  }
                  document.getElementById("reset-password") &&
                      document
                          .getElementById("reset-password")
                          .setAttribute("aria-expanded", true);

                  window.scroll({
                      top:
                          document.getElementById("reset-password").getBoundingClientRect()
                              .top +
                          window.scrollY -
                          60,
                      left: 0,
                      behavior: "smooth",
                  });
              };
              setTimeout(() => {
                  const items = document.querySelectorAll("button");
                  function toggleAccordion(e) {
                      const itemToggle = this.getAttribute("aria-expanded");

                      for (let item of items) {
                          item.setAttribute("aria-expanded", false);
                          item.children[2] &&
                              item.children[2].setAttribute("aria-expanded", false);
                      }

                      if (itemToggle === "false") {
                          this.setAttribute("aria-expanded", true);
                          this.children[2] &&
                              this.children[2].setAttribute("aria-expanded", true);

                          var bodyRect = document.body.getBoundingClientRect(),
                              offset = e.target.top - bodyRect.top;

                          // window.scroll({
                          //         top: e.target.getBoundingClientRect().top + window.scrollY - 100,
                          //         left: 0,
                          //         behavior: 'smooth'
                          // });
                      }
                  }

                  items.forEach((item) =>
                      item.addEventListener("click", toggleAccordion)
                  );

                  let rightSideItemList = document.querySelectorAll(
                      ".category-title-faq"
                  );

                  let leftSideItemList = document.querySelectorAll(
                      ".accordion-parent-faq"
                  );

                  function actSelectedItem(e) {
                      e.stopPropagation();

                      console.error(e.target.dataset.identity);

                      rightSideItemList.forEach((rightSideItem) => {
                          rightSideItem.classList.remove("category-title-faq-active");
                      });

                      leftSideItemList.forEach((leftSideItem) => {
                          if (leftSideItem.dataset.identity == e.target.dataset.identity) {
                              leftSideItem.classList.remove("display-none");
                          } else {
                              leftSideItem.classList.add("display-none");
                          }
                      });

                      e.target.classList.add("category-title-faq-active");
                  }

                  rightSideItemList.forEach((rightSideItem) =>
                      rightSideItem.addEventListener("click", actSelectedItem)
                  );
              }, 500);

          } else {
              setTimeout(() => {
                  const items = document.querySelectorAll(".accordion-faq .outer-button");
                  const innerItems = document.querySelectorAll(".innerAccordion-faq .inner-button");
                  function toggleAccordion(e) {
                      console.log("toggleAccordion");
                      const itemToggle = this.getAttribute("aria-expanded");

                      for (let item of items) {
                          item.setAttribute("aria-expanded", false);
                          item.children[2] && item.children[2].setAttribute("aria-expanded", false);
                      }

                      if (itemToggle === "false") {

                          this.setAttribute("aria-expanded", true);
                          this.children[2] && this.children[2].setAttribute("aria-expanded", true);

                          var bodyRect = document.body.getBoundingClientRect(),
                              offset = e.target.top - bodyRect.top;

                          window.scroll({
                              top: e.target.getBoundingClientRect().top + window.scrollY - 10,
                              left: 0,
                              behavior: 'smooth'
                          });
                      }
                  }
                  function toggleInnerAccordion(e) {
                      console.log("toggleInnerAccordion");
                      console.log(e.target.offsetTop)
                      const itemToggle = this.getAttribute("aria-expanded");

                      for (let item of innerItems) {
                          item.setAttribute("aria-expanded", false);
                          item.children[2] && item.children[2].setAttribute("aria-expanded", false);
                      }

                      if (itemToggle === "false") {

                          this.setAttribute("aria-expanded", true);
                          this.children[2] && this.children[2].setAttribute("aria-expanded", true);

                          var bodyRect = document.body.getBoundingClientRect(),
                              offset = e.target.top - bodyRect.top;

                          window.scroll({
                              top: e.target.getBoundingClientRect().top + window.scrollY - 100,
                              left: 0,
                              behavior: 'smooth'
                          });
                      }
                  }

                  items.forEach((item) => item.addEventListener("click", toggleAccordion));
                  innerItems.forEach((item) => item.addEventListener("click", toggleInnerAccordion));

              }, 500)


              window.actScrollView = function () {

                  const items = document.querySelectorAll("button");

                  for (let item of items) {
                      item.setAttribute("aria-expanded", false);
                      item.children[2] && item.children[2].setAttribute("aria-expanded", false);
                  }
                  document.getElementById('reset-password') && document.getElementById('reset-password').setAttribute("aria-expanded", true);

                  window.scroll({
                      top: document.getElementById('reset-password').getBoundingClientRect().top + window.scrollY - 100,
                      left: 0,
                      behavior: 'smooth'
                  });
              }

          }

      },
      fetchFaqData(url) {
          fetch(url)
              .then((res) => {
                  return res.text();
              })
              .then((result) => {
                  this.dataset = result;
                  this.actInitFaq(window.screen.width > 720 ? true : false);
              });
      },
  },
  mounted() {
      this.defaultThemeColor = localStorage.getItem('theme') || 'theme-dark';
      this.isThemeDark = this.defaultThemeColor === 'theme-dark';

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      window.scrollTo(0, 0);

      let faqCodeDesktop ="https://d2xowqqrpfxxjf.cloudfront.net/static/cspace/faq/en/faq-web.html";
      let faqDesktopLight ="https://d2xowqqrpfxxjf.cloudfront.net/static/cspace/faq/en/faq-weblight.html";
      let faqCodeMobile = "https://d2xowqqrpfxxjf.cloudfront.net/static/cspace/faq/en/faq.html";
      let faqMobileLight = "https://d2xowqqrpfxxjf.cloudfront.net/static/cspace/faq/en/faqlight.html";

      let urlFaq;
      if (window.screen.width > 720) {
          urlFaq = this.isThemeDark ? faqCodeDesktop : faqDesktopLight;
      } else {
          urlFaq = this.isThemeDark ? faqCodeMobile : faqMobileLight;
      }

      this.fetchFaqData(urlFaq);
  },
};
</script>
<style>
.my-faq {
    font-size: 1.5rem;
    text-align: center;
    color: rgb(119, 119, 119);
    margin-top: 4rem;
}
@media screen and (max-width: 600px){
.my-faq{
    margin-top: 9rem;
}
}
</style>